export default "__VITE_ASSET___M4hQYm3__"